import type { AllianceBuffs } from '../types/alliance.ts';

export const ALLIANCE_CONFIG = {
  CREATE_COST_CREDITS: 5000,
  BASE_MAX_MEMBERS: 10,
  MEMBERS_PER_LEVEL: 5,
  NAME_MIN_LENGTH: 3,
  NAME_MAX_LENGTH: 30,
  TAG_MIN_LENGTH: 2,
  TAG_MAX_LENGTH: 4,

  // Tech tree levels, requirement in total donated credits, and corresponding buffs
  TECH_LEVELS: [
    { level: 1, required_donations: 0, buffs: { resource_yield_percent: 0, fleet_speed_percent: 0, storage_capacity_percent: 0 } },
    { level: 2, required_donations: 10000, buffs: { resource_yield_percent: 5, fleet_speed_percent: 0, storage_capacity_percent: 5 } },
    { level: 3, required_donations: 30000, buffs: { resource_yield_percent: 10, fleet_speed_percent: 5, storage_capacity_percent: 10 } },
    { level: 4, required_donations: 70000, buffs: { resource_yield_percent: 15, fleet_speed_percent: 10, storage_capacity_percent: 15 } },
    { level: 5, required_donations: 150000, buffs: { resource_yield_percent: 25, fleet_speed_percent: 15, storage_capacity_percent: 25 } },
  ],
};

export function getAllianceBuffs(techLevel: number): AllianceBuffs {
  const current = ALLIANCE_CONFIG.TECH_LEVELS.slice().reverse().find(t => techLevel >= t.level);
  return current?.buffs ?? { resource_yield_percent: 0, fleet_speed_percent: 0, storage_capacity_percent: 0 };
}

export function calculateAllianceTechLevel(totalDonated: number): number {
  let level = 1;
  for (const t of ALLIANCE_CONFIG.TECH_LEVELS) {
    if (totalDonated >= t.required_donations) {
      level = t.level;
    }
  }
  return level;
}
